import React from 'react';
import { Spinner as OvalSpinner } from '@teetsh/app/src/components/Spinner';

type Size = 'xs' | 'md';
export default function Spinner({
  className,
  size = 'xs',
}: {
  size?: Size;
  className?: string;
}) {
  return (
    <OvalSpinner
      className={className}
      size={size === 'xs' ? '1.2rem' : '1.5rem'}
      strokeWidth={16}
    />
  );
}
